import { Header, SideNav, useState, useEffect, BreadCrumbs, Select, components, decryptData, axios, useNavigate, handleApiError, FormatDate, Revoke, RevokeArrow, CustomModal, ProgressBar, EnrolledUserSkeleton, SuccessfullVector, DeleteWarning, EnrolledUserEmpty } from "../../../UploadCourses/UploadCoursesImport";
import "./EnrolledUser.css";

const customStyles = {
  container: (provided, state) => ({
    ...provided,
    fontSize: "1rem",
    fontWeight: "400",
    width: "12rem",
    marginBottom: "0.7rem",
  }),

  menu: (provided) => ({
    ...provided,
    display: "block",
    width: "100%",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "var(--bs-body-color)",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    zIndex: 30,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "10.625rem",
    overflowY: "auto",
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    maxHeight: "2rem",
    overflow: "auto",
    marginleft: "1rem",
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "lightGrey" : "white",
    color: state.isSelected ? "black" : "black",
  }),

  placeholder: (provided) => ({
    ...provided,
    display: "block",
    width: "100%",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "grey",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  }),
};

const additionalOptions = [
  { label: "Enrolled", value: "Enrolled" },
  { label: "Ongoing", value: "Ongoing" },
  { label: "Completed", value: "Completed" },
];

const isUserOverdue = (user) => {
  const isCompleted = String(user?.courseStatusName || "").toLowerCase() === "completed";
  const isRevoked = String(user?.courseStatusName || "").toLowerCase() === "revoked";
  if (isCompleted || isRevoked) return false;
  if (!user?.courseEndDate) return false;
  const endDate = new Date(user.courseEndDate);
  return !isNaN(endDate.getTime()) && new Date() > endDate;
};

const EnrolledUser = () => {
  const [dataState, setDataState] = useState({
    data: [],
    selectedFilterOptions: [],
    originalData: [],
    isLoading: true,
  });

  const [isOverdueOnly, setIsOverdueOnly] = useState(false);

  const [paginationState, setPaginationState] = useState({
    currentPage: 1,
    resultsPerPage: 10,
  });

  const [isOpen, setIsOpen] = useState({
    isModalOpen: false,
    modalType: "",
    modalTitle: "",
    modalMessage: "",
    icon: null,
    userId: 0,
    modalState: ""
  });

  const storedCourseId = sessionStorage.getItem("cId");
  const storedCourseName = sessionStorage.getItem("cName");

  const navigate = useNavigate();

  const CheckboxOption = ({ getStyles, Icon, isDisabled, isFocused, isSelected, children, innerProps, ...rest }) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex",
    };

    const props = {
      ...innerProps,
      onMouseDown,
      onMouseUp,
      onMouseLeave,
      style,
    };

    return (
      <components.Option {...rest} isDisabled={isDisabled} isFocused={isFocused} isSelected={isSelected} getStyles={getStyles} innerProps={props}>
        <input type="checkbox" checked={isSelected} />
        &nbsp;
        {children}
      </components.Option>
    );
  };

  let parsedObject;
  const data = localStorage.getItem("userData");
  data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");

  const fetchEnrolledUserList = async () => {
    const url = `${process.env.REACT_APP_API_URL_DOTNET}/Course/getEnrolledUsersByCourseId?courseId=${storedCourseId}`;
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]}`,
    };

    try {
      const response = await axios.get(url, { headers });
      if (response.status === 200) {
        let filteredData = response.data.result;
        setDataState((prevData) => ({
          ...prevData,
          data: filteredData,
          originalData: filteredData,
          isLoading: false,
        }));
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      const errorResp = error.response ? error.response : null;
      handleApiError(errorResp, navigate);
    }
  };

  const handleCancel = () => {
    setIsOpen((prevData) => ({
      ...prevData,
      isModalOpen: false,
      modalType: "",
      modalTitle: "",
      modalMessage: "",
      icon: null,
      userId: 0,
    }));
    if (isOpen.modalState === "success") {
      if (arrayCurrentResults?.length === 0) {
        navigate("/admin/lms/total-uploaded-courses");
      }
      setIsOpen((prevData) => ({
        ...prevData,
        modalState: "",
      }));
    }
  };

  const handleConfirm = async (e) => {
    let parsedObject;
    const data = localStorage.getItem("userData");
    data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");

    const url = `${process.env.REACT_APP_API_URL_DOTNET}/Course/manageEnrollment`;
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]}`,
    };
    const body = {
      courseId: storedCourseId,
      userId: [isOpen.userId],
      assignedById: parsedObject["decoded"]["Id"],
      isAssigned: false,
      courseName: storedCourseName
    };

    try {
      const response = await axios.post(url, body, { headers });
      if (response.status === 200) {
        handleCancel();
        setIsOpen((prevData) => ({
          ...prevData,
          isModalOpen: true,
          modalType: "success",
          modalTitle: "User Revoked",
          modalMessage: "User revoked successfully",
          icon: <SuccessfullVector />,
          modalState: "success"
        }));
        setDataState((prevData) => ({
          ...prevData,
          data: prevData.data.filter((obj) => obj.userId != response.data.result[0].id),
          originalData: prevData.data.filter((obj) => obj.userId != response.data.result[0].id),
        }));
      } else {
        setIsOpen((prevData) => ({
          ...prevData,
          isModalOpen: true,
          modalType: "error",
          modalTitle: "User Not Revoked",
          modalMessage: "Error occured while revoking user",
          icon: <DeleteWarning />,
        }));
        handleCancel();
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      const statusCode = error.response ? error.response : null;
      handleApiError(statusCode, navigate);
    }
  };

  const handleFilters = () => {
    setDataState((prevData) => {
      const { originalData, selectedFilterOptions } = prevData;
      let filterItems = originalData || [];

      if (selectedFilterOptions && selectedFilterOptions.length > 0) {
        filterItems = filterItems.filter((val) => selectedFilterOptions.includes(val.courseStatusName));
      }

      if (isOverdueOnly) {
        filterItems = filterItems.filter((val) => isUserOverdue(val));
      }

      return {
        ...prevData,
        data: filterItems,
      };
    });
  };

  const handleFilterChange = (selectedOptions) => {
    setDataState((prevData) => ({
      ...prevData,
      selectedFilterOptions: selectedOptions?.map((option) => option.value),
    }));
  };

  const handleclickfunc = (userId) => {
    setIsOpen((prevData) => ({
      ...prevData,
      isModalOpen: true,
      modalType: "confirm",
      modalTitle: "Revoke",
      modalMessage: "Are you sure you want to revoke this user? The user will be revoked from the enrolled list",
      icon: <RevokeArrow />,
      userId: userId,
    }));
  };

  const truncate = (str, maxLength) => {
    if (str?.length > maxLength) {
      return str.slice(0, maxLength) + "...";
    } else {
      return str;
    }
  };

  const totalDataLength = dataState.data?.length || 0;
  const totalPaginationPages = Math.max(1, Math.ceil(totalDataLength / paginationState.resultsPerPage));
  const arrayStartIndex = (paginationState.currentPage - 1) * paginationState.resultsPerPage;
  const arrayEndIndex = arrayStartIndex + paginationState.resultsPerPage;
  const arrayCurrentResults = dataState.data?.slice(arrayStartIndex, arrayEndIndex);

  const getPaginationItems = () => {
    if (totalPaginationPages <= 7) {
      return Array.from({ length: totalPaginationPages }, (_, i) => i + 1);
    }

    const currentPage = paginationState.currentPage;
    const items = [1];

    if (currentPage > 3) {
      items.push("left-ellipsis");
    }

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPaginationPages - 1, currentPage + 1);

    for (let page = startPage; page <= endPage; page++) {
      items.push(page);
    }

    if (currentPage < totalPaginationPages - 2) {
      items.push("right-ellipsis");
    }

    items.push(totalPaginationPages);
    return items;
  };

  const paginationItems = getPaginationItems();

  useEffect(() => {
    fetchEnrolledUserList();
  }, [additionalOptions]);

  useEffect(() => {
    handleFilters();
  }, [dataState.selectedFilterOptions, isOverdueOnly]);

  useEffect(() => {
    setPaginationState((prevState) => {
      const maxPage = Math.max(1, Math.ceil(totalDataLength / prevState.resultsPerPage));

      if (prevState.currentPage > maxPage) {
        return {
          ...prevState,
          currentPage: maxPage,
        };
      }

      return prevState;
    });
  }, [totalDataLength, paginationState.resultsPerPage]);

  return (
    <>
      <div style={{ marginBottom: "3rem" }}>
        <Header />
        <SideNav />
      </div>
      <div className="container-fluid enrolled-user-table-container d-flex flex-column">
        <div style={{ marginLeft: "1rem" }}>
          <div className="row ">
            <div className="col-12">
              <div className="enrolled-user-course-nav-bar">
                <BreadCrumbs />
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-between">
              <div className="enrolled-user-courses-heading">
                <p>Enrolled Users</p>
              </div>
              <div className="enrolled-user-courses-heading">
                <p>Course Name: <span className="fw-bold" title={sessionStorage.getItem("cName")}>{truncate(sessionStorage.getItem("cName"), 50)}</span></p>
              </div>
              <div className="d-flex align-items-center">
                <p className="filter-head mb-0" style={{ marginTop: 0 }}>Course Progress</p>
                <div className="enrolled-user-courses-inner-filter">
                  <Select
                    styles={customStyles}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option: ({ children, ...innerProps }) => <CheckboxOption {...innerProps}>{children}</CheckboxOption>,
                    }}
                    options={additionalOptions}
                    menuShouldBlockScroll
                    placeholder="Select Progress..."
                    onChange={handleFilterChange}
                  />
                </div>
                <div className="form-check d-flex align-items-center gap-2 mb-0 ms-3" style={{ cursor: "pointer" }}>
                  <input
                    className="form-check-input pointer mt-0"
                    type="checkbox"
                    id="adminOverdueFilter"
                    checked={isOverdueOnly}
                    onChange={(e) => {
                      setIsOverdueOnly(e.target.checked);
                      setPaginationState((prevState) => ({ ...prevState, currentPage: 1 }));
                    }}
                  />
                  <label htmlFor="adminOverdueFilter" className="form-check-label pointer filter-head mb-0" style={{ marginTop: 0 }}>
                    Overdue
                  </label>
                </div>
              </div>
            </div>
          </div>
          <table className="table table-striped-custom">
            <thead>
              <tr>
                <th className="col enroll-user-table-head revoke-name-col">Name</th>
                <th className="col enroll-user-table-head revoke-progress-col">Course Progress</th>
                <th className="col enroll-user-table-head revoke-start-col text-center">Start Date</th>
                <th className="col enroll-user-table-head revoke-end-col text-center">End Date</th>
                <th className="col enroll-user-table-head revoke-action-col text-center">Revoke</th>
              </tr>
            </thead>
            <tbody>
              {dataState.isLoading ? (
                <>
                  <EnrolledUserSkeleton />
                  <EnrolledUserSkeleton />
                  <EnrolledUserSkeleton />
                  <EnrolledUserSkeleton />
                </>
              ) : arrayCurrentResults.length === 0 ? (
                <>
                  <tr>
                    <td></td>
                    <td colSpan="6" className=" d-flex align-items-center justify-content-center">
                      <div className="enrolled-empty-state">
                        <EnrolledUserEmpty />
                        <div className="enrolled-empty-heading">No user has been enrolled yet</div>
                        <div className="enrolled-empty">We’ll notify you when new user arrives.</div>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </>
              ) : (
                arrayCurrentResults.map((val, ind) => (
                  <tr className={`report-table-tr ${ind % 2 === 0 ? "enrolled-striped-even-rows" : "enrolled-striped-odd-rows"}`} key={ind}>
                    <td className="bg-transparent" style={{ verticalAlign: "middle", height: "40px" }}>
                      <div className="name-column">
                        <div className="revoke-tag justify-content-center">
                          <div
                            className="revoke-tag1 pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              sessionStorage.setItem("uId", val.userId);
                              navigate("/admin/lms/course-report");
                            }}
                          >
                            {val?.firstName || ""} {val?.lastName || ""}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className={`tag2 tag2-adjustment progress-height bg-transparent`}>
                      <div>
                        <div>
                          <ProgressBar completedCount={val.completedModuleCount} totalCount={val.totalModuleCount} courseStatus={val.courseStatusName} />
                          {isUserOverdue(val) && (
                            <div className="mt-1 d-flex">
                              <span
                                style={{
                                  backgroundColor: "#fff0f0",
                                  color: "#d92d20",
                                  border: "1px solid #fda29b",
                                  borderRadius: "10px",
                                  fontSize: "0.72rem",
                                  fontWeight: 500,
                                  padding: "1px 8px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px"
                                }}
                              >
                                ● Overdue
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td className={`tag2 text-center tag2-adjustment td-height bg-transparent`}>{FormatDate(val.courseStartDate)}</td>
                    <td className={`tag2 text-center tag2-adjustment td-height bg-transparent`}>{FormatDate(val.courseEndDate)}</td>
                    <td className={`tag2 text-center tag2-adjustment td-height bg-transparent`}>
                      <button className="btn p-0 m-0 border-0" type="button">
                        <Revoke
                          // className={`${val.courseStatusName === "Enrolled" || val.courseStatusName === "Completed" || val.courseStatusName === "Overdue" ? "" : "revoke-user-image"}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleclickfunc(val.userId);
                          }}
                        />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td className="fw-bold" style={{ fontSize: "14px" }} colSpan={2}>
                  Total Items: {dataState.data?.length}
                </td>
                <td colSpan={6}>
                  <div className="d-flex justify-content-end t-items">
                    <div className="d-flex align-items-center">
                      <p className="me-2 mb-0 res-per-page">Results per page</p>
                      <select
                        className="form-select m-2 r-page"
                        value={paginationState.resultsPerPage}
                        onChange={(event) => {
                          setPaginationState((prevState) => ({
                            ...prevState,
                            resultsPerPage: Number(event.target.value),
                            currentPage: 1,
                          }));
                        }}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                      </select>
                      <ul className="pagination mb-0">
                        <li className={`page-item me-1 ${paginationState.currentPage === 1 ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => {
                              setPaginationState((prevState) => {
                                if (prevState.currentPage !== 1) {
                                  return {
                                    ...prevState,
                                    currentPage: prevState.currentPage - 1,
                                  };
                                }
                                return prevState;
                              });
                              window.scrollTo(0, 0);
                            }}
                          >
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 1.5L1.5 7L7 12.5" stroke={paginationState.currentPage === 1 ? "#A4A3A7" : "#28519E"} strokeWidth="1.5" />
                            </svg>
                          </button>
                        </li>
                        {paginationItems.map((item, index) =>
                          typeof item === "number" ? (
                            <li key={item} className={`page-item me-1 ${item === paginationState.currentPage ? "active" : ""}`}>
                              <button
                                className="page-link rounded pagination-styling fw-bold"
                                onClick={() => {
                                  setPaginationState((prevState) => ({
                                    ...prevState,
                                    currentPage: item,
                                  }));
                                  window.scrollTo(0, 0);
                                }}
                              >
                                {item}
                              </button>
                            </li>
                          ) : (
                            <li key={`${item}-${index}`} className="page-item me-1 disabled">
                              <span className="page-link rounded pagination-styling fw-bold">...</span>
                            </li>
                          )
                        )}
                        <li className={`page-item ${paginationState.currentPage === totalPaginationPages ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => {
                              setPaginationState((prevState) => {
                                if (prevState.currentPage < totalPaginationPages) {
                                  return {
                                    ...prevState,
                                    currentPage: prevState.currentPage + 1,
                                  };
                                }
                                return prevState;
                              });
                              window.scrollTo(0, 0);
                            }}
                          >
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 12.5L6.5 7L1 1.5" stroke={paginationState.currentPage === totalPaginationPages ? "#A4A3A7" : "#28519E"} strokeWidth="1.5" />
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      {isOpen.isModalOpen && (
        <CustomModal
          modalProps={{
            icon: isOpen.icon,
            show: isOpen.isModalOpen,
            type: isOpen.modalType,
            title: isOpen.modalTitle,
            message: isOpen.modalMessage,
            cancelText: "No, Cancel",
            confirmText: "Yes, Revoke",
            onCancel: handleCancel,
            onConfirm: handleConfirm,
          }}
        />
      )}
    </>
  );
};

export default EnrolledUser;
